import clsx from 'clsx'

import { parseLocationStopValue } from '@/modules/CombinedLogs/helpers/location'
import { MileageLossCode, UpdatedLog } from '@/types/logs'
import { useBusStops } from '../../hooks/useBusStops'

import styles from './UpdatedRecordsTable.module.scss'

interface Props {
    log: UpdatedLog
}

export const Location = ({ log }: Props) => {
    const { allStops } = useBusStops()

    const isDefaultLocationOption = !(log.code && log.code in MileageLossCode)

    const locationFromName =
        log.locationFrom &&
        allStops.find((item) => {
            const { stopNumber, direction } = parseLocationStopValue(log.locationFrom)
            return item.stopNumber === stopNumber && item.direction === direction
        })?.stopName

    const locationToName =
        log.locationTo &&
        allStops.find((item) => {
            const { stopNumber, direction } = parseLocationStopValue(log.locationTo)
            return item.stopNumber === stopNumber && item.direction === direction
        })?.stopName

    if (isDefaultLocationOption) {
        return (
            <div
                className={clsx(styles.updatedContainer, {
                    [styles.updatedHighlighted]: log.propertiesChanged.includes('locationfrom'),
                })}
            >
                {log.locationFrom || <span className={styles.textBold}>Add location</span>}
            </div>
        )
    }

    return (
        <div className={styles.locationContainer}>
            <div
                className={clsx(styles.updatedContainer, {
                    [styles.updatedHighlighted]: log.propertiesChanged.includes('locationfrom'),
                })}
            >
                {locationFromName ? (
                    <p>
                        <span className={styles.hint}>From:</span> {locationFromName}
                    </p>
                ) : (
                    <span className={styles.textBold}>Add from</span>
                )}
            </div>
            <div
                className={clsx(styles.updatedContainer, {
                    [styles.updatedHighlighted]: log.propertiesChanged.includes('locationto'),
                })}
            >
                {locationToName ? (
                    <p>
                        <span className={styles.hint}>To:</span> {locationToName}
                    </p>
                ) : (
                    <span className={styles.textBold}>Add to</span>
                )}
            </div>
        </div>
    )
}
